'use strict';

const cellType = require('./cell-type');
const outputFormat = require('./output-format');

module.exports = {
  CELL_TYPE: cellType,
  OUTPUT_FORMAT: outputFormat,
};
